import styled from 'styled-components';
import { LORAX } from 'HubStyleTokens/colors';
import ViralTrackingPixel from '../viral-tracking/ViralTrackingPixel';
import { getTrackedIntermediateUrl, getTrackedSignupUrl } from '../viral-tracking/viral-urls';
import { Flow } from 'signup-constants/Flow';
import { TextStyle, StyledViralIcon } from '../components/ViralComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledViralLink = styled.a.withConfig({
  displayName: "ViralLink__StyledViralLink",
  componentId: "sc-10siehn-0"
})(["", " justify-content:", ";"], TextStyle, props => props.justifyContent || 'left');
const ViralLink = ({
  children,
  environment = 'prod',
  flow = Flow.Crm,
  portalId,
  viralLinkType,
  additionalParams,
  isExternalLink,
  intermediatePage,
  use,
  justifyContent,
  ariaLabel,
  iconSize = 18,
  iconClassName
}) => {
  const href = intermediatePage ? getTrackedIntermediateUrl({
    redirectPage: intermediatePage,
    viralLinkType,
    environment,
    portalId,
    additionalParams
  }) : getTrackedSignupUrl({
    flow,
    viralLinkType,
    environment,
    additionalParams
  });
  if (use === 'primary') {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(StyledViralLink, {
        justifyContent: justifyContent,
        href: href,
        target: "_blank",
        rel: "noopener nofollow",
        className: "flex-row",
        "data-test-id": `viral-link-${viralLinkType}`,
        "aria-label": ariaLabel,
        children: [/*#__PURE__*/_jsx(StyledViralIcon, {
          className: iconClassName,
          "data-test-id": `spocket-icon-${viralLinkType}`,
          name: "sprocket",
          size: iconSize,
          color: LORAX
        }), /*#__PURE__*/_jsx("span", {
          children: children
        })]
      }), /*#__PURE__*/_jsx(ViralTrackingPixel, {
        environment: environment,
        portalId: portalId,
        viralLinkType: viralLinkType,
        isExternalLink: isExternalLink
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("a", {
      href: href,
      target: "_blank",
      rel: "noopener nofollow",
      "data-test-id": `viral-link-${viralLinkType}`,
      "aria-label": ariaLabel,
      children: children
    }), /*#__PURE__*/_jsx(ViralTrackingPixel, {
      environment: environment,
      portalId: portalId,
      viralLinkType: viralLinkType,
      isExternalLink: isExternalLink
    })]
  });
};
export default ViralLink;